import { defineComponent } from 'vue';
import ErrorDetailsCode from '@/presentation/pages/error-details/error-details.code';

export default defineComponent({
	setup: () => {
		const code = new ErrorDetailsCode();

		return {
			selectedImport: code.selectedImport,
			navigateToOverviewPage: code.navigateToOverviewPage.bind(code)
		};
	}
});
